import Vue from 'vue'

const BRANDS_KEY = 'sharedBrands'
const MODELS_KEY = 'sharedModelTypes'

export const brandFilterStore = Vue.observable({
  selBrands: JSON.parse(localStorage.getItem(BRANDS_KEY)) || [],
  selModelTypes: JSON.parse(localStorage.getItem(MODELS_KEY)) || [],
})

export function persistBrands(brands) {
  brandFilterStore.selBrands = brands
  if (brands.length > 0) {
    localStorage.setItem(BRANDS_KEY, JSON.stringify(brands))
  } else {
    localStorage.removeItem(BRANDS_KEY)
  }
}

export function persistModelTypes(types) {
  brandFilterStore.selModelTypes = types
  if (types.length > 0) {
    localStorage.setItem(MODELS_KEY, JSON.stringify(types))
  } else {
    localStorage.removeItem(MODELS_KEY)
  }
}



// WEBPACK FOOTER //
// ./src/brandFilter.store.js